export const MAX_COPAY_DEDUCTIBLE_TO_DISPLAY_AMOUNT = 40;

export const enum PatientIntakeQuestionType {
  A1C = "a1c",
  ALCOHOL_FREQUENCY = "alcoholFrequency",
  ADDRESS = "address",
  BARIATRIC_SURGERY = "bariatricSurgery",
  BLOOD_PRESSURE = "bloodPressure",
  CHOOSE_PHARMACY = "choosePharmacy",
  CONDITIONS = "conditions",
  EATING_DISORDER = "eatingDisorder",
  FAMILY_HISTORY = "familyHistory",
  HEART_RATE = "heartRate",
  HEIGHT_WEIGHT = "heightWeight",
  MEDICATION = "medication",
  MEDICATION_ALLERGIES = "medicationAllergies",
  MEDICATION_ALLERGIES_LIST = "medicationAllergiesList",
  MEDICATION_LIST = "medicationList",
  ORIGINAL_CONDITIONS = "originalConditions",
  OTHER_SURGERIES = "otherSurgeries",
  OTHER_SURGERIES_LIST = "otherSurgeriesList",
  PATIENT_ACKNOWLEDGEMENT = "patientAcknowledgement",
  PATIENT_ATTESTATION = "patientAttestation",
  PHONE_NUMBER = "phoneNumber",
  PREGNANT_OR_BREASTFEEDING = "pregnantOrBreastfeeding",
  SEARCH_PHARMACY = "searchPharmacy",
  SELF_ASSESSED_HEALTH = "selfAssessedHealth",
  SUICIDE_OR_SELF_HARM = "suicideOrSelfHarm",
  USE_DRUGS = "useDrugs",
  USE_TOBACCO = "useTobacco",
}

export const enum SchedulerFlow {
  INITIAL = "initial",
  FOLLOWUP = "followup",
  MAWL = "mawl",
}

export const enum ConsultType {
  EM = "EM",
  RPM = "RPM",
  MAWL = "MAWL",
  MAWLRPM = "MAWLRPM",
}

export function getConsultTypeForSchedulerFlow(
  flow: SchedulerFlow
): ConsultType {
  switch (flow) {
    case SchedulerFlow.MAWL:
      return ConsultType.MAWL;
    case SchedulerFlow.FOLLOWUP:
    case SchedulerFlow.INITIAL:
    default:
      return null;
  }
}

export function getSchedulerFlowForConsultType(
  consultType: ConsultType
): SchedulerFlow {
  switch (consultType) {
    case ConsultType.EM:
      return SchedulerFlow.INITIAL;
    case ConsultType.MAWL:
      return SchedulerFlow.MAWL;
    case ConsultType.RPM:
    case ConsultType.MAWLRPM:
      return SchedulerFlow.FOLLOWUP;
    default:
      return null;
  }
}

export enum EligibleStateCode {
  CA = "CA",
  FL = "FL",
}

// This was being used UserSegment/features.ts in combination with a BMI of >= 25 to determine eligibility for telehealth.
// That has been stopped for now, but we're keeping this here in case we need it again in the future.
export const ELIGIBLE_HEALTH_RISKS = [
  "heartDiseaseOrStroke",
  "highBloodPressure",
  "diabetes",
  "nash",
  "kidneyDisease",
  "highCholesterol",
  "asthma",
  "insomnia",
];

export type PayerInfo = {
  payerId: string;
  workflowId: string;
};

export enum Payer {
  anthem = "anthem",
  bsca = "bsca",
  cigna = "cigna",
  uhc = "uhc",
  aetna = "aetna",
  kaiserPermanente = "kaiserPermanente",
  medicare = "medicare",
  bcbs = "bcbs",
  tricare = "tricare",
  humana = "humana",
}

export enum SurveyType {
  // create a new consult
  Schedule = "Schedule",
  // move an existing consult to a new time
  Reschedule = "Reschedule",
}

export const EligiblePayerMappings: {
  [stateCode in EligibleStateCode]: {
    [payer in Payer]?: PayerInfo;
  };
} = {
  CA: {
    anthem: { payerId: "47198", workflowId: "weight-management-anthem" },
    bsca: { payerId: "BS001", workflowId: "weight-management-bsca" },
    uhc: { payerId: "87726", workflowId: "weight-management-uhc" },
  },
  FL: {
    bcbs: { payerId: "00590", workflowId: "weight-management-bcbs-fl" },
    aetna: { payerId: "60054", workflowId: "weight-management-aetna-fl" },
  },
};

export const CONSENT_CHECKBOX_ID = "consents";
